import { AppStoreButtons } from '../../../../../components/Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { Heading } from '../../../../../components/Heading/Heading';
import { Text } from '../../../../../components/Text/Text';

interface IProps {
  speciesName: string;
  sourceId?: string;
}

export const NearbyWatersCTA = ({ speciesName, sourceId }: IProps) => {
  return (
    <div className="relative flex flex-col rounded-lg sm:hidden">
      <div className="absolute inset-x-0 top-0 flex flex-col">
        <div className="relative flex w-full items-center rounded-lg py-2.5 blur-md">
          <div className="relative flex w-full items-center gap-2">
            <div className="bg-twilight h-28 w-28 rounded-l-lg md:rounded-l-xl" />
            <div className="flex grow flex-col">
              <div className="bg-lake-fog h-28 w-full rounded-r-lg md:rounded-r-xl" />
            </div>
          </div>
        </div>
        <div className="relative flex w-full items-center rounded-lg blur-md">
          <div className="relative flex w-full items-center gap-2">
            <div className="bg-twilight h-14 w-28 rounded-l-lg" />
            <div className="flex grow flex-col">
              <div className="bg-lake-fog h-14 w-full rounded-r-lg" />
            </div>
          </div>
        </div>
      </div>
      <div className="z-mid mx-auto flex max-w-72 flex-col items-center justify-center gap-4 pt-7 pb-4 text-center">
        <Heading className="mb-0" variant="2xs" as="span">
          {`Find top spots for ${speciesName} fishing`}
        </Heading>
        <Text className="mb-0" variant="sm" as="span">
          Use the Fishbrain app to filter by species and discover the best waters for catching roach
          near you.
        </Text>
        <AppStoreButtons orientation="vertical" source={'nearbyWatersCTA'} sourceId={sourceId} />
      </div>
    </div>
  );
};
